import { Pipe, PipeTransform } from '@angular/core';
import { ApplicationSettings } from "./../core/coresettings";

@Pipe({ name: 'crewActive', pure: false })
export class CrewActive implements PipeTransform {

    transform(items: any[]): any[] {
        if (!items) {
            return null;
        }

        if (ApplicationSettings.instance.showInactive) {
            return items;
        }

        return items.filter(value => value.Active);
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/core/crew-active.pipe.ts